import { Spinner } from 'app/components/ui/spinner';
import { Header } from 'app/components/header';
import { useMobileScreen } from 'app/shared/hooks/use-mobile-screen';
import { useContentBackNavigation } from 'app/shared/hooks/use-content-back-navigation';

/**
 * Loading screen for the content render page: a centered spinner (desktop and mobile).
 *
 * A content-shaped skeleton was tried but didn't look good, so we're back to a plain
 * spinner. On mobile it also renders the miniapp's OWN Header (React, instant) so the
 * loading screen keeps a reachable back/close from the first frame — the native
 * container header stays hidden because it animates in on the SDK-bridge delay and reads
 * as jumpy. The wrapper is full-height + relative so the spinner centres and the
 * absolutely-positioned Header anchors to the top of the screen. (VIS-366)
 */
export const ContentLoading = (): JSX.Element => {
  const { isMobileScreen } = useMobileScreen();
  const onBackClick = useContentBackNavigation();

  return (
    <div
      data-testid="content-loading"
      className="relative flex min-h-screen w-full items-center justify-center bg-white"
    >
      {isMobileScreen && <Header onBackClick={onBackClick} />}
      <Spinner />
    </div>
  );
};
